import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Container, Card, CardContent } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaLock, FaUser, FaSignInAlt } from 'react-icons/fa';
import Bg from '../Images/about.jpg';

const Login = () => {
  const navigate = useNavigate();

  // Hardcoded login credentials with roles
  const users = [
    { username: 'admin', password: 'admin123', role: 'admin', redirect: '/Admin/' },
    { username: 'TG', password: 'TG@ICTAZ123', role: 'accounts', redirect: '/Admin/accounts' },
    { username: 'Auditor', password: 'Auditor@ICTAZ123', role: 'accounts', redirect: '/Admin/accounts' }
  ];

  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');

  const darkGlassStyle = {
    background: "rgba(0, 0, 36, 0.9)",
    backdropFilter: "blur(20px)",
    border: "1px solid rgba(0, 217, 255, 0.2)",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.4)",
  };

  const inputStyle = {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "rgba(255, 255, 255, 0.05)",
      borderRadius: "12px",
      color: "white",
      "& fieldset": {
        borderColor: "rgba(0, 217, 255, 0.3)",
      },
      "&:hover fieldset": {
        borderColor: "rgba(0, 217, 255, 0.5)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#00d9ff",
      },
    },
    "& .MuiInputLabel-root": {
      color: "rgba(255, 255, 255, 0.7)",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "#00d9ff",
    },
  };

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleLogin = (e) => {
    e.preventDefault();
    const user = users.find(
      (u) => u.username === credentials.username && u.password === credentials.password
    );

    if (user) {
      localStorage.setItem('isAuthenticated', 'true');
      localStorage.setItem('userRole', user.role);
      navigate(user.redirect);
    } else {
      setError('Invalid username or password');
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: `linear-gradient(135deg, rgba(0, 0, 36, 0.95) 0%, rgba(10, 25, 47, 0.9) 50%, rgba(0, 0, 36, 0.95) 100%), url(${Bg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: 4,
      }}
    >
      <Container maxWidth="sm">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Card
            sx={{
              borderRadius: "25px",
              ...darkGlassStyle,
              overflow: "hidden",
            }}
          >
            <CardContent sx={{ p: { xs: 3, md: 5 } }}>
              {/* Header */}
              <Box sx={{ textAlign: 'center', mb: 4 }}>
                <motion.div
                  animate={{ rotate: [0, 10, -10, 0] }}
                  transition={{ duration: 2, repeat: Infinity }}
                >
                  <Box
                    sx={{
                      width: 80,
                      height: 80,
                      borderRadius: "20px",
                      background: "linear-gradient(135deg, #00d9ff, #00b4d8)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mx: 'auto',
                      mb: 3,
                      boxShadow: "0 8px 30px rgba(0, 217, 255, 0.4)",
                    }}
                  >
                    <FaLock size={35} color="white" />
                  </Box>
                </motion.div>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 800,
                    background: "linear-gradient(90deg, #ffffff, #00d9ff)",
                    backgroundClip: "text",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                >
                  Admin Login
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ color: 'rgba(255, 255, 255, 0.7)', mt: 1 }}
                >
                  Access the ICTAZ NIPA Chapter Admin Panel
                </Typography>
              </Box>

              {/* Login Form */}
              <Box component="form" onSubmit={handleLogin}>
                <Box sx={{ mb: 3 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                    <FaUser size={16} color="#00d9ff" />
                    <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                      Username
                    </Typography>
                  </Box>
                  <TextField
                    fullWidth
                    placeholder="Enter your username"
                    variant="outlined"
                    name="username"
                    value={credentials.username}
                    onChange={handleChange}
                    sx={inputStyle}
                  />
                </Box>

                <Box sx={{ mb: 3 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                    <FaLock size={16} color="#00d9ff" />
                    <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                      Password
                    </Typography>
                  </Box>
                  <TextField
                    fullWidth
                    placeholder="Enter your password"
                    type="password"
                    variant="outlined"
                    name="password"
                    value={credentials.password}
                    onChange={handleChange}
                    sx={inputStyle}
                  />
                </Box>

                {error && (
                  <motion.div
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                  >
                    <Box
                      sx={{
                        p: 2,
                        mb: 3,
                        borderRadius: '12px',
                        background: 'rgba(255, 82, 82, 0.1)',
                        border: '1px solid rgba(255, 82, 82, 0.3)',
                      }}
                    >
                      <Typography color="error" sx={{ textAlign: 'center' }}>
                        {error}
                      </Typography>
                    </Box>
                  </motion.div>
                )}

                <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
                  <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    sx={{
                      py: 1.5,
                      borderRadius: "12px",
                      background: "linear-gradient(135deg, #00d9ff, #00b4d8)",
                      fontSize: "1.1rem",
                      fontWeight: 600,
                      textTransform: "none",
                      boxShadow: "0 4px 20px rgba(0, 217, 255, 0.4)",
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      "&:hover": {
                        background: "linear-gradient(135deg, #00b4d8, #0096c7)",
                        boxShadow: "0 6px 25px rgba(0, 217, 255, 0.5)",
                      },
                    }}
                  >
                    <FaSignInAlt size={18} />
                    Login
                  </Button>
                </motion.div>
              </Box>
            </CardContent>
          </Card>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Login;
